import { CmsLinkResourceComponent, CmsResource, CmsResourceComponent, ItemTypeName, ResourceType } from '@insync-students-lib/services/cms/cms-api.types';
export function getComponent(resource: CmsResource, language?: string): CmsResourceComponent | undefined {
  if (language === undefined || language === '') {
    return resource.components.at(0);
  }
  return resource.components.find(c => c.language === language);
}
function getTypedComponent<T>(resource: CmsResource, language?: string): T | undefined {
  const untypedComponent = getComponent(resource, language);
  return untypedComponent ? untypedComponent as T : undefined;
}
export function getResourceType(resource: CmsResource): ResourceType {
  const firstComponent = resource.components.at(0);
  return firstComponent?.componentType ?? ResourceType.Invalid;
}
export function resourceIsLink(resource: CmsResource): boolean {
  return getResourceType(resource) === ResourceType.Link;
}
export function externalResourceUrl(resource: CmsResource, language?: string): string {
  if (!resourceIsLink(resource)) {
    return '';
  }
  const linkComponent = getTypedComponent<CmsLinkResourceComponent>(resource, language);
  const url = linkComponent?.contentReference;
  return url || '';
}
export function resourceUrl(parentItemType: ItemTypeName, parentItemId: string, resource: CmsResource): string {
  if (resourceIsLink(resource)) {
    return '';
  }
  return `/resources/view/${parentItemType.toLowerCase()}/${parentItemId}/${resource.id}`;
}